<template>
    <div>
        <TrolleyNumberDialog
            :is-open="trolleyNumberDialog"
            :plate-data="currentPlate"
            @on-close="closeTrolleyNumberDialog"
        />
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="1000px"
            transition="slide-y-transition"
            eager
            :persistent="jobPlatesLoading"
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        <template>
                            Lista montaży dla zlecenia <strong>{{ job.number }}</strong>
                        </template>
                    </h1>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="jobPlates"
                        :loading="jobPlatesLoading"
                        :mobile-breakpoint="0"
                        hide-default-footer
                        disable-pagination
                        name="jobPlatesData"
                    >
                        <template #item.paper="{item}">
                            <template v-if="item.paper">
                                {{ item.paper }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.machine="{item}">
                            {{ item.machine.symbol }}
                        </template>
                        <template #item.status="{item}">
                            <template>
                                <v-icon
                                    v-if="item.status"
                                    small
                                    color="success"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon v-else small color="error">
                                    mdi-close
                                </v-icon>
                            </template>
                        </template>
                        <template #item.previews="{item}">
                            <template v-if="item.previews.length > 0">
                                <v-row>
                                    <v-col v-for="(preview, index) in item.previews" :key="index" cols="auto">
                                        <v-btn
                                            icon
                                            data-sentry-label="Pobierz"
                                            @click="openInNewTab(preview.url)"
                                        >
                                            {{ preview.previewSide }}
                                            <v-icon color="primary">
                                                mdi-download
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Wykonaj"
                                            :disabled="item.status ? true : false"
                                            v-on="on"
                                            @click="showTrolleyNumberDialog(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-check
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Wykonaj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        :disabled="jobPlatesLoading"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import TrolleyNumberDialog from './TrolleyNumberDialog'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import { apiConfig } from '@/config'

export default {
    name: 'JobPlatesDialog',
    components: {
        TrolleyNumberDialog
    },
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        jobData: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            job: {
                number: null
            },
            currentPlate: null,
            trolleyNumberDialog: false,
            headers: [
                {
                    text: 'Numer montażu',
                    value: 'plateNumber',
                    sortable: false,
                },
                {
                    text: 'Papier',
                    value: 'paper',
                    sortable: false,

                },
                {
                    text: 'Kolorystyka',
                    value: 'colour',
                    sortable: false,
                },
                {
                    text: 'Maszyna',
                    value: 'machine',
                    sortable: false,
                },
                {
                    text: 'Wykonane',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Podglądy',
                    value: 'previews',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        jobPlates() {
            return this.$store.state.prepress.prepressJobs.jobPlates
        },
        jobPlatesLoading() {
            return this.$store.state.prepress.prepressJobs.jobPlatesLoading
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.job = JSON.parse(JSON.stringify(this.jobData))
                this.getPlateJobs()
            }
        }
    },
    methods: {
        getPlateJobs() {
            this.$store.dispatch('prepress/getJobPlates', {
                query: `?prepressJobNumber=${this.job.number}`
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        openInNewTab(file) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            window.open(`${mediaRoot}${file}`, '_blank').focus()
        },
        showTrolleyNumberDialog(item) {
            this.currentPlate = item
            this.$emit('on-close')
            this.trolleyNumberDialog = true
        },
        closeTrolleyNumberDialog(showJobPlatesDialog) {
            if (showJobPlatesDialog) {
                this.$emit('on-show', this.job)
            } else {
                this.$emit('get-jobs')
                this.$emit('get-aggregated-jobs')
            }

            this.$store.dispatch('prepress/clearJobPlates')
            this.trolleyNumberDialog = false
        },
        onClose() {
            this.$store.dispatch('prepress/clearJobPlates')
            if (!this.jobPlatesLoading) {
                this.$emit('on-close')

                setTimeout(() => {
                    this.job.number = null
                }, 500)
            }
        }
    }
}
</script>
